/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

    exports.hasVisibilityRole = function (roles) {
        var result = false;
        if (roles) {
           var rolesArr = roles.split('|');
           var allowedRoles = window.b$.portal.loggedInUserGroup;
           for (var role in rolesArr) {
              result = $.inArray(rolesArr[role], allowedRoles) > -1;
              break;
           }
        }
        return result;
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/button-visibility-filter.js
// module id = 40
// module chunks = 0